import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type { PaidInvoicesParams, PaidInvoicesResponse } from './types';

const getPaidInvoices = async (
  params: PaidInvoicesParams,
  options?: RequestHandlerOptions
) => {
  const request = () =>
    apiClient.get('/operations/bank/deposit/invoices/paid', { params });
  const response = await handleRequest<PaidInvoicesResponse>(request, options);
  return response.data;
};

export { getPaidInvoices };
